import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header, Image, Button, Popup } from 'semantic-ui-react';

import { useAppState } from '../../contexts/AppContext';
import { signInRedirect } from '../../services/auth';

export function Login() {
  const { authState, appState, loading, logout } = useAppState();
  const navigate = useNavigate();
  const { loggedIn, userEmail } = authState;
  const { practitionerId } = appState;

  // See `components/auth/Login.tsx` for why sign-out goes through `logout()`
  // rather than the auth service.
  const handleClick = async () => {
    if (loggedIn) {
      logout();
      return;
    }
    await signInRedirect();
  };

  useEffect(() => {
    if (authState.loggedIn && !loading) {
      navigate('/', { replace: true });
    }
  }, [authState.loggedIn, loading, navigate]);

  const label = loggedIn ? 'Logout' : 'Login';
  return (
    <>
      <Header as="h5" floated="left">
        <Image src={'/images/doc.png'} />
        <Header.Content>
          <h2>{loggedIn ? 'Care Betty' : 'Welcome to NourishedRx'}</h2>
        </Header.Content>
      </Header>
      <Header floated="right">
        <Popup
          flowing
          trigger={
            <div>
              {loggedIn && (
                <Button color="red" onClick={handleClick}>
                  {' '}
                  {label}
                </Button>
              )}
              {loggedIn && !practitionerId && (
                <h5>No Practioner Id is associated to the Logged in User</h5>
              )}
              {!loggedIn && (
                <Button color="blue" onClick={handleClick}>
                  {' '}
                  {label}
                </Button>
              )}
            </div>
          }
        >
          <Popup.Content>{userEmail ? userEmail : 'Click here to Login'}</Popup.Content>
        </Popup>
      </Header>
      <img src="/images/food.png" alt="background" />
    </>
  );
}
